import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { logEvent, processStoredEvents } from '@/pages/api/v1/utils';
import { grantFBConsent } from '@/utils/analytics/facebook/grantFBConsent';
import { grantUETConsent } from '@/utils/analytics/microsoft/grantUETConsent';
import { FacebookPixel } from './FacebookPixel';
import { GTag } from './GTag';
import { MicrosoftClarity } from './MicrosoftClarity';
import { MicrosoftUET } from './MicrosoftUET';
import { TikTokPixel } from './TikTokPixel';
export const Tracking = () => {
  const [allowsTracking, setAllowsTracking] = useState(false);
  const lastLoggedPath = useRef<string>('');
  const router = useRouter();
  useEffect(() => {
    const onAccept = () => {
      if (window.Cookiebot?.consent?.marketing) {
        setAllowsTracking(true);
        grantFBConsent();
        grantUETConsent();
      }
    };
    const onDecline = () => {
      if (!window.Cookiebot?.consent?.marketing) {
        setAllowsTracking(false);
      }
    };
    window.addEventListener('CookiebotOnAccept', onAccept);
    window.addEventListener('CookiebotOnDecline', onDecline);
    return () => {
      window.removeEventListener('CookiebotOnAccept', onAccept);
      window.removeEventListener('CookiebotOnDecline', onDecline);
    };
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined' && router.isReady) {
      if (router.asPath !== lastLoggedPath.current) {
        lastLoggedPath.current = router.asPath;
        void logEvent({
          event_type: 'page_view',
          asPath: router.asPath
        });
      }
      void processStoredEvents();
    }
  }, [router.isReady, router.asPath]);
  return <>
      <GTag data-sentry-element="GTag" data-sentry-source-file="index.tsx" />
      <FacebookPixel data-sentry-element="FacebookPixel" data-sentry-source-file="index.tsx" />
      <MicrosoftClarity data-sentry-element="MicrosoftClarity" data-sentry-source-file="index.tsx" />
      <MicrosoftUET data-sentry-element="MicrosoftUET" data-sentry-source-file="index.tsx" />
      {allowsTracking && <TikTokPixel />}
    </>;
};